import { pubsub } from '@services';
import { notyf } from '@modules';
import { d as debounce } from './debounce-CFN_LA0O.js';

class CustomProductOption extends HTMLElement {
  #unsubscribers = [];

  connectedCallback() {
    this.init();

    // check if the custom product option is checked
    // this is used to prevent restoring the value when the page is loaded
    if (this.customProductOption?.checked) {
      this.restoreValue();
      this.addCustomValue();
    }
  }

  init() {
    // customElements
    this.customProductOption = this.closest('fieldset')?.querySelector(
      '[data-custom-product-option]'
    );
    this.customPriceField = this.querySelector('input[type="number"]');
    this.form = this.closest('product-form');

    // event listers
    this.customPriceField.addEventListener('input', this.#handleInput);

    // subscribers
    this.#unsubscribers.push(
      pubsub.subscribe('variant:change', ({ data: { value } }) => {
        console.log('sub event: ', value);
      })
    );
  }

  /**
   * Handle the input event
   * @param {Event} event - The input event
   */
  #handleInput = debounce((event) => {
    this.value = event.target.value;

    if (!this.validateValue()) return;

    this.saveValue();
    this.customProductOption.checked = true;
    this.customProductOption.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }, 1000);

  /**
   * Validate the value
   * @returns {boolean} - True if the value is valid, false otherwise
   */
  validateValue() {
    const { min, max } = this.customPriceField.attributes;
    if (this.value < parseInt(min.value) || this.value > parseInt(max.value)) {
      notyf.error(
        window.toast_translations.product.custom_price_error
          .replace('[MIN]', min.value)
          .replace('[MAX]', max.value)
      );

      this.form.querySelector('button[type="submit"]').disabled = true;
      return false;
    }
    this.form.querySelector('button[type="submit"]').disabled = false;
    return true;
  }

  saveValue() {
    window.localStorage.setItem('custom_product_option_value', this.value);
  }

  restoreValue() {
    const value = window.localStorage.getItem('custom_product_option_value');
    if (value) {
      this.customPriceField.value = value;
    }
  }

  addCustomValue() {
    this.productForm = this.closest('product-form').querySelector('form');

    const customPriceInput = document.createElement('input');
    customPriceInput.type = 'hidden';
    customPriceInput.name = 'properties[_custom_price]';
    customPriceInput.value = this.querySelector('input[type="number"]').value;

    this.productForm.appendChild(customPriceInput);
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }
}

customElements.define('custom-product-option', CustomProductOption);
